export { default as ErrorBoundary } from './errorboundary';
